import type { Cart } from '@ab-core/graphql/dist';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { UPDATE_CART } from './updateCart';

type UpdateLineItemType = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: Cart;
    updateLineItem: (options?: MutationFunctionOptions) => void;
};
const UpdateLineItem = (
    cartId?: string,
    sku?: string,
    lineItemId?: string,
    quantity = 1,
    positionText = ''
): UpdateLineItemType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(undefined);
    const [pending, setPending] = useState(false);

    const [updateLineItem, { loading }] = useMutation(UPDATE_CART, {
        variables: {
            cartIds: cartId,
            lineItemInput: {
                quantity,
                sku,
                id: lineItemId,
                fields: positionText
                    ? [
                          {
                              name: 'lineitem-positionstext',
                              value: positionText
                          }
                      ]
                    : []
            }
        },
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        }
        // refetchQueries: [{ query: CARTS }, { query: CART }]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
            setSuccess(false);
            setError(false);
        }
    }, [loading]);

    return {
        updateLineItem,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};

export default UpdateLineItem;
